import { IsString, IsOptional, IsUUID } from 'class-validator';

export class CancelEventFromMailDto {
  @IsOptional()
  @IsString()
  signature?: string;

  @IsOptional()
  @IsUUID()
  nodeId?: string;

  @IsOptional()
  @IsString()
  action?: string;
}
